import { Modal } from 'foundations-components/transitional/components/Modal';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { DialogCloseButton } from 'foundations-components/transitional/components/DialogCloseButton';
import { Flex } from 'foundations-components/components/Flex';
import { Box } from 'foundations-components/transitional/components/Box';
import { DialogHeader } from 'foundations-components/transitional/components/DialogHeader';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { View } from 'foundations-components/components/View';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const EnrollPaymentLinksModalWrapper = ({
  Body,
  Footer,
  Header,
  DialogContextHeader = /*#__PURE__*/_jsx(_Fragment, {}),
  onClose
}) => {
  return /*#__PURE__*/_jsxs(Modal, {
    "data-test-id": "enroll-payment-links-modal",
    use: "conversational",
    width: 900,
    children: [/*#__PURE__*/_jsx(DialogCloseButton, {
      "data-test-id": "enroll-payment-links-close-button",
      onClick: onClose
    }), /*#__PURE__*/_jsxs(Flex, {
      children: [/*#__PURE__*/_jsxs(Box, {
        children: [/*#__PURE__*/_jsx(View, {
          margin: "1100",
          marginBlockEnd: "0",
          children: DialogContextHeader
        }), /*#__PURE__*/_jsx(DialogHeader, {
          marginBlockEnd: "200",
          paddingBlockStart: "0",
          children: Header
        }), /*#__PURE__*/_jsx(DialogBody, {
          paddingInlineStart: "1100",
          children: Body
        }), /*#__PURE__*/_jsx(DialogFooter, {
          marginBlockEnd: "500",
          children: Footer
        })]
      }), /*#__PURE__*/_jsx(Box, {
        alignSelf: "center",
        children: /*#__PURE__*/_jsx(Illustration, {
          "data-test-id": "enroll-payment-links-illustration",
          name: "payments",
          width: "70%"
        })
      })]
    })]
  });
};
export default EnrollPaymentLinksModalWrapper;